export default "__VITE_ASSET__e02ae895__"